export default __webpack_public_path__ + "static/media/Vector47.08dbd86a.svg";